module.exports = __webpack_public_path__ + "static/img/040902.5ee9a699.png";